import type { Messages } from '../catalogue.en'

/**
 * Processings: long work over a Patient's material that any member who may
 * read it can follow, stop and remove — the workspace tile, the registry, the
 * page of one processing and the names of its closed lists.
 */
export const processing: Partial<Messages> = {
  'processing.title': 'עיבודים',
  'processing.kind.externalEntries': 'רשומות רפואיות ממסמכים',
  'processing.status.queued': 'בתור',
  'processing.status.running': 'בביצוע',
  'processing.status.needsAction': 'ממתין לפעולה',
  'processing.status.failed': 'נכשל',
  'processing.status.succeeded': 'הושלם',
  'processing.status.cancelled': 'בוטל',
  'processing.stage.externalEntries.recognizing': 'זיהוי טקסט',
  'processing.stage.externalEntries.segmenting': 'סימון עמודים',
  'processing.stage.externalEntries.grouping': 'איתור אירועי טיפול',
  'processing.stage.externalEntries.extracting': 'מילוי רשומות',
  'processing.stage.externalEntries.review': 'סקירה',
  'processing.tileDescription': 'זיהוי וניתוח מסמכי מטופלים',
  'processing.itemTitle': 'עיבוד',
  'processing.columnKind': 'סוג',
  'processing.columnPatient': 'מטופל',
  'processing.columnSubject': 'קבצים',
  'processing.columnRequester': 'הופעל על ידי',
  'processing.columnStarted': 'התחיל',
  'processing.columnStage': 'שלב והתקדמות',
  'processing.columnStatus': 'סטטוס',
  'processing.columnUpdated': 'עודכן',
  'processing.columnActions': 'פעולות',
  'processing.filterMine': 'שלי',
  'processing.loading': 'טוען עיבודים',
  'processing.loadFailed': 'לא ניתן לטעון את העיבודים.',
  'processing.empty': 'אין עיבודים עדיין',
  'processing.emptyDetail': 'עיבוד מתחיל מקבצי המטופל: סמנו מסמכים ובחרו מה לעשות בהם.',
  'processing.filteredEmpty': 'אין עיבודים התואמים את הסינון',
  'processing.filteredEmptyDetail': 'תחילה מוצגים עיבודים שלא הסתיימו; נקו את סינון הסטטוס כדי לראות את כולם.',
  'processing.resultCountOne': 'עיבוד אחד',
  'processing.resultCountMany': '{count} עיבודים',
  'processing.progress': '{done} מתוך {total}',
  'processing.awaiting': 'לבדיקה: {count}',
  'processing.cancel': 'ביטול',
  'processing.remove': 'מחיקה',
  'processing.cancelNamed': 'ביטול העיבוד {name}',
  'processing.removeNamed': 'מחיקת העיבוד {name}',
  'processing.cancelTitle': 'לבטל את העיבוד?',
  'processing.cancelDetail': 'לא יתחילו שלבים חדשים. מה שכבר נשמר ברשומה יישאר.',
  'processing.cancelKeep': 'להשאיר',
  'processing.cancelConfirm': 'ביטול העיבוד',
  'processing.cancelFailed': 'לא ניתן היה לבטל את העיבוד. נסו שוב.',
  'processing.removeTitle': 'למחוק את העיבוד?',
  'processing.removeDetail': 'העיבוד יוסר מהרשימה אצל כולם. מה שנשמר ממנו ברשומה יישאר.',
  'processing.removeKeep': 'להשאיר',
  'processing.removeConfirm': 'מחיקת העיבוד',
  'processing.removeFailed': 'לא ניתן היה למחוק את העיבוד. נסו שוב.',
  'processing.actChanged': 'העיבוד השתנה בינתיים, וכעת מוצג מצבו הנוכחי.',
  'processing.actGone': 'העיבוד הזה כבר לא קיים.',
  'processing.invalidLink': 'הקישור לעיבוד אינו תקין',
  'processing.invalidLinkDetail': 'פתחו את העיבוד שוב מרשימת העיבודים.',
  'processing.notFound': 'העיבוד לא נמצא',
  'processing.notFoundDetail': 'ייתכן שהוא נמחק או שאין לך גישה אליו.',
  'processing.loadingOne': 'טוען את העיבוד',
  'processing.factFinished': 'הסתיים',
  'processing.factCancelledBy': 'בוטל על ידי',
  'processing.unknownKind': 'גרסה זו של היישום אינה יכולה להציג את הפרטים של סוג עיבוד זה.',
  'processing.patientLabel': 'מטופל',
}
